import React, { useState, useEffect } from "react";
import ApplyForm from "./components/ApplyForm";
import AdminDashboard from "./components/AdminDashboard";
import { FiEdit2, FiGrid, FiLogOut, FiMenu, FiX } from "react-icons/fi";
import EligibilityBox from "./components/EligibilityBox";
import InternshipInfoCard from "./components/InternshipInfoCard";
import "./styles/App.css";

export default function App() {
  const [view, setView] = useState("apply");
  const [adminToken, setAdminToken] = useState(localStorage.getItem("adminToken"));
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  /* -----------------------------
     NEW: SHOW INTERNSHIP CARD ONCE
  ----------------------------- */
  const [showInfoCard, setShowInfoCard] = useState(() => {
    return localStorage.getItem("internshipCardClosed") !== "true";
  });

  const closeInfoCard = () => {
    localStorage.setItem("internshipCardClosed", "true");
    setShowInfoCard(false);
  };

  /* --- Disable Body Scroll When Popup Visible --- */
  useEffect(() => {
    if (showInfoCard) {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }
  }, [showInfoCard]);

  const handleLogout = () => {
    localStorage.removeItem("adminToken");
    setAdminToken(null);
    setView("admin");
    window.location.reload();
  };

  const handleChangeView = (nextView) => {
    setView(nextView);
    setIsMobileMenuOpen(false);
  };

  const handleLogoutFromMenu = () => {
    setIsMobileMenuOpen(false);
    handleLogout();
  };

  return (
    <>
      {/* ---------------------------
          POPUP + BLUR BACKGROUND
      ---------------------------- */}
      {showInfoCard && (
        <>
          <div className="internship-overlay"></div>
          <div className="internship-card-wrapper">
            <InternshipInfoCard onClose={closeInfoCard} />
          </div>
        </>
      )}

      <div className={`app-root ${showInfoCard ? "blur-active" : ""}`}>
        <header className="topbar">
          <div className="topbar-inner">
            <h1 className="brand">Dawat-E-Islami Internship Program</h1>

            <nav className="controls" role="tablist" aria-label="Primary">
              <button
                className={`tab-btn ${view === "apply" ? "active" : ""}`}
                onClick={() => handleChangeView("apply")}
              >
                <span className="tab-icon"><FiEdit2 /></span>
                <span className="tab-text">Apply for Internship</span>
              </button>

              <button
                className={`tab-btn ${view === "admin" ? "active" : ""}`}
                onClick={() => handleChangeView("admin")}
              >
                <span className="tab-icon"><FiGrid /></span>
                <span className="tab-text">Admin Dashboard</span>
              </button>

              {adminToken && (
                <div style={{ marginLeft: "auto" }}>
                  <button className="tab-btn logout-btn" onClick={handleLogout}>
                    <span className="tab-icon"><FiLogOut /></span>
                    <span className="tab-text">Logout</span>
                  </button>
                </div>
              )}
            </nav>

            <button
              className="mobile-menu-toggle"
              aria-label="Toggle navigation menu"
              onClick={() => setIsMobileMenuOpen((p) => !p)}
            >
              {isMobileMenuOpen ? <FiX /> : <FiMenu />}
            </button>
          </div>
        </header>

        {isMobileMenuOpen && (
          <div
            className="mobile-menu-backdrop"
            onClick={() => setIsMobileMenuOpen(false)}
          >
            <div
              className="mobile-menu"
              onClick={(e) => e.stopPropagation()}
            >
              <button
                className={`tab-btn mobile-tab-btn ${view === "apply" ? "active" : ""}`}
                onClick={() => handleChangeView("apply")}
              >
                <span className="tab-icon"><FiEdit2 /></span>
                <span className="tab-text">Apply for Internship</span>
              </button>

              <button
                className={`tab-btn mobile-tab-btn ${view === "admin" ? "active" : ""}`}
                onClick={() => handleChangeView("admin")}
              >
                <span className="tab-icon"><FiGrid /></span>
                <span className="tab-text">Admin Dashboard</span>
              </button>

              {adminToken && (
                <button
                  className="tab-btn mobile-tab-btn logout-btn"
                  onClick={handleLogoutFromMenu}
                >
                  <span className="tab-icon"><FiLogOut /></span>
                  <span className="tab-text">Logout</span>
                </button>
              )}
            </div>
          </div>
        )}

        <main className="main-area" id={view === "apply" ? "apply-panel" : "admin-panel"}>
          {view === "apply" ? (
            <div className="apply-page">
              <EligibilityBox
                emoji="🕌"
                text="If you are a true Aashiq-e-Rasool ﷺ , Aashiq-e-Aala Hazrat and currently pursuing or have completed BE/B.Tech, BSc, BCA, CS/IT, or an equivalent degree — this program is made for you!"
              />
              <EligibilityBox
                emoji="📍"
                text="The program will be conducted in Pune Maharashtra offering you a chance to work closely with a team of dedicated professionals and contribute to real-time Islamic IT projects that serve the Ummah."
              />
              <ApplyForm />
            </div>
          ) : (
            <AdminDashboard setAdminToken={setAdminToken} />
          )}
        </main>

        <footer className="site-footer">
          <small className="footer-support">
            For queries: <a href="mailto:It@dawateislamiindia.org">It@dawateislamiindia.org</a>
          </small>
          <small>© {new Date().getFullYear()} Dawat-E-Islami. All rights reserved.</small>
        </footer>
      </div>
    </>
  );
}